import QuoteHeaderMobile from './QuoteHeaderMobile'
export default QuoteHeaderMobile
export * from './QuoteHeaderMobile'
